var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-comment-viewpoint-wrapper"},[_c(_setup.cardItem,{attrs:{"tips":""}},[_c('div',{staticClass:"card-title"},[_c('trans',{domProps:{"innerHTML":_vm._s(_setup.$t('10a9d4'))}})],1),_c('el-select',{staticClass:"card-type-sec",attrs:{"size":"mini"},model:{value:(_setup.viewType),callback:function ($$v) {_setup.viewType=$$v},expression:"viewType"}},[_c('el-option',{staticClass:"mtm-click",attrs:{"value":2,"label":_setup.$t('13f033'),"data-click-type":JSON.stringify({
            classify: 'home',
            action: 'competition_opinion',
            name: '表扬率',
          })}}),_c('el-option',{staticClass:"mtm-click",attrs:{"value":1,"label":_setup.$t('641a89'),"data-click-type":JSON.stringify({
            classify: 'home',
            action: 'competition_opinion',
            name: '表扬量',
          })}}),_c('el-option',{staticClass:"mtm-click",attrs:{"value":4,"label":_setup.$t('34e6da'),"data-click-type":JSON.stringify({
            classify: 'home',
            action: 'competition_opinion',
            name: '批评率',
          })}}),_c('el-option',{staticClass:"mtm-click",attrs:{"value":3,"label":_setup.$t('ba1770'),"data-click-type":JSON.stringify({
            classify: 'home',
            action: 'competition_opinion',
            name: '批评量',
          })}})],1),_c('div',{staticClass:"chart-box"},[_c(_setup.CommonChartsAdapter,{attrs:{"type":"RadarArea","loading":_setup.loading,"datas":_setup.currentRadarData},on:{"chartClick":_setup.clickRadar}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }